<template>
<div class="cvip-alert-wrap">
	<div class="cvip-alert" :style="{width: widthnew, height: heightnew, margin: marginnew}">
		<div class="alert-hd">
			<span class="alert-title" v-if="title">{{title || ''}}</span>
			<span class="close-btn" @click="onHide">×</span>
		</div>
		<div class="alert-bd">
			<slot></slot>
		</div>
		<div class="alert-ft" v-if="buttonTxt">
            <span class="alert-btn cancel-btn" @click="onCancel" v-if="cancelBtnTxt">{{cancelBtnTxt}}</span>
			<span class="alert-btn" @click="onConfirm">{{buttonTxt || ''}}</span>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'CvipAlert',
	props: {
		title: String,
		buttonTxt: String,
		widthnew: {
			type: String,
			default: '640px'
		},
		heightnew: {
			type: String,
			default: '360px'
		},
		marginnew: {
			type: String,
			default: '-180px auto'
        },
        cancelBtnTxt: {
			type: String
		}
	},
	methods: {
		onHide() {
			this.$emit('on-hide');
			this.$emit('on-close');
		},
		onConfirm() {
			this.$emit('on-confirm');
			this.$emit('on-hide');
        },
        onCancel() {
            this.$emit("on-cancel");
            this.$emit('on-hide');
        }
	}
}
</script>

<style lang="scss" scoped>
.alert-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 5px;
    &.icon-warn {
        background: url("../../assets/imgs/alert-warn.png") 0 0 no-repeat;
    }
    &.icon-error {
        background: url("../../assets/imgs/alert-error.png") 0 0 no-repeat;
    }
    &.icon-success {
        background: url("../../assets/imgs/alert-success.png") 0 0 no-repeat;
    }
}
.cvip-alert-wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    color: #333;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif, "微软雅黑";
    font-size: 14px;
    z-index: 1001;
    .cvip-alert {
        position: relative;
        top: 50%;
        padding: 15px;
        // margin: -180px auto;
        // width: 640px;
        // height: 360px;
        background-color: #fff;
        box-sizing: border-box;
        .alert-hd {
            position: relative;
            height: 20px;
            line-height: 20px;
            text-align: center;
        }
        .alert-bd {
            padding: 15px;
            text-align: center;
            box-sizing: border-box;
            span {
                display: inline-block;
                font-size: 16px;
                vertical-align: middle;
            }
        }
        .alert-ft {
            padding: 15px;
            text-align: center;
            box-sizing: border-box;
        }
        .alert-btn {
            display: inline-block;
            width: 160px;
            height: 40px;
            line-height: 40px;
            background: #ff552e;
            border-radius: 2px;
            font-size: 16px;
            color: #fff;
            text-align: center;
            cursor: pointer;
            &:hover {
                opacity: 0.9;
            }
        }
        .cancel-btn {
            margin-right: 10px;
            background: #eee;
            color: #666;
        }
        .close-btn {
            position: absolute;
            top: -4px;
            right: -4px;
            width: 25px;
            height: 25px;
            line-height: 21px;
            background: #fff;
            color: #a6a6a6;
            font-size: 28px;
            text-align: center;
            border-radius: 2px;
            cursor: pointer;
            &:hover {
                background: #d8d8d8;
                color: #fff;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Alert.vue?328fb834